var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
function RouteIcon() {
    return (_jsx("svg", __assign({ width: 33, height: 32, viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M25.833 20.24V9.333A5.332 5.332 0 0 0 20.5 4a5.332 5.332 0 0 0-5.333 5.333v13.334c0 1.466-1.2 2.666-2.667 2.666a2.674 2.674 0 0 1-2.667-2.666V11.76C11.38 11.2 12.5 9.733 12.5 8c0-2.213-1.787-4-4-4s-4 1.787-4 4c0 1.733 1.12 3.2 2.667 3.76v10.907A5.332 5.332 0 0 0 12.5 28a5.332 5.332 0 0 0 5.333-5.333V9.333c0-1.466 1.2-2.666 2.667-2.666 1.467 0 2.667 1.2 2.667 2.666V20.24A3.995 3.995 0 0 0 24.5 28c2.213 0 4-1.787 4-4 0-1.733-1.12-3.2-2.667-3.76ZM8.5 9.333c-.733 0-1.333-.6-1.333-1.333s.6-1.333 1.333-1.333 1.333.6 1.333 1.333-.6 1.333-1.333 1.333Zm16 16c-.733 0-1.333-.6-1.333-1.333s.6-1.333 1.333-1.333 1.333.6 1.333 1.333-.6 1.333-1.333 1.333Z", fill: "#fff" }) })));
}
export default RouteIcon;
//# sourceMappingURL=RouteIcon.js.map